import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const FormModal = ({
  title,
  isOpen,
  toggle,
  headerToggle = true,
  backdrop = "static",
  size,
  footerButtons,
  children,
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop={backdrop} size={size}>
      {headerToggle ? (
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
      ) : (
        <ModalHeader>{title}</ModalHeader>
      )}
      {children && <ModalBody>{children}</ModalBody>}
      <ModalFooter>{footerButtons}</ModalFooter>
    </Modal>
  );
};

export default FormModal;
